var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyToClipboardIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8922_168475",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8922_168475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.13913 12.0431C5.71935 12.0431 5.36163 11.8953 5.06596 11.5996C4.77029 11.304 4.62246 10.9462 4.62246 10.5265V2.62214C4.62246 2.20236 4.77029 1.84464 5.06596 1.54897C5.36163 1.2533 5.71935 1.10547 6.13913 1.10547H12.0435C12.4632 1.10547 12.821 1.2533 13.1166 1.54897C13.4123 1.84464 13.5601 2.20236 13.5601 2.62214V10.5265C13.5601 10.9462 13.4123 11.304 13.1166 11.5996C12.821 11.8953 12.4632 12.0431 12.0435 12.0431H6.13913ZM6.13913 10.5265H12.0435V2.62214H6.13913V10.5265ZM3.28913 14.8931C2.86935 14.8931 2.51163 14.7453 2.21596 14.4496C1.92029 14.154 1.77246 13.7962 1.77246 13.3765V3.95547H3.28913V13.3765H10.7101V14.8931H3.28913Z",
    fill: "#1D5AE8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyToClipboardIcon);
export default __webpack_public_path__ + "static/media/CopyToClipboardIcon.f8cd7ffcfa0c41e08b7ab7ca84df0189.svg";
export { ForwardRef as ReactComponent };